import React from "react";
import { useState } from "react";
import useSWR from "swr";
import "./styles/Compras.css";
import CardCompras from "./component/CardCompras.js"

let baseUrl;
if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
else baseUrl='https://app-formacion.vercel.app';

const getProducto = (url) => 
    fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
    }).then((res) => {
        if(!res.ok) throw new Error(res.statusText);
        return res.json();
    });

//consultar compras
const getComprasEnriquecidas = async ([urlCompras]) => {
const compras = await getProducto(urlCompras);

const comprasConInfo = await Promise.all(
    compras.map(async (compra) => {
      const productosInfo = await Promise.all(
        compra.Id_Contenido.map(async (idContenido) => {
          // Llamada a endpoint de producto
          try {
            const detalle = await getProducto(
              `${baseUrl}/api/productos/${idContenido}`
            );
            return {
              ...detalle.producto,
              tutor: detalle.tutor,
              rating: detalle.rating,
            };
          } catch {
            return null;
          }
        })
      );
      return {
        ...compra,
        //productos: productosInfo.filter((p) => p !== null),
        productos: productosInfo,
      };
    })
  );
  comprasConInfo.sort(
    (a, b) => new Date(b.Fecha).getTime() - new Date(a.Fecha).getTime()
  );
  return comprasConInfo;
};



const Compras = () => {

     const [usuario] = useState(() => {
            const usuarioAlmacenado = localStorage.getItem("userLogueado");
            return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
    });

    const { data: compras = [], error, isValidating, mutate: mutateCompras } = useSWR(
        [`${baseUrl}/api/compras/search/usuario/${usuario?._id}`],
        getComprasEnriquecidas,
        {
        dedupingInterval: 30 * 60 * 1000,   // 30 min caché
        revalidateOnFocus: false,           // no recargar al volver al tab
        revalidateOnReconnect: false,       // no recargar al reconectar
        keepPreviousData: true,             // mantén la lista anterior mientras recargas
        }
    );

    if (error) {
        return (
          <div className="noCompras">
            <p>Error cargando compras: {error.message}</p>;
          </div>
        )
    }
       
    return(
        <div className="principal">
            <h1>Tus compras</h1>   
            <div className="containerPedido">
                { isValidating ? (
                    <div className="noCompras">
                        <p>Cargando compras...</p>
                    </div>
                ) : compras && compras.length > 0 ? ( 
                    compras?.map((compra) => (
                        <CardCompras key={compra._id} compra={compra} mutateCompras={mutateCompras}/>
                    ))
                ) : ( 
                    <div className="noCompras">
                        <p>Aún no ha realizado ninguna compra</p>
                    </div>
                )}
            </div>
        </div> 
    );
};


export default Compras;